import React from "react"

function IconLock({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="lock"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-lock"
      {...props}
    >
      <path
        d="M12.017 1.8a5.364 5.364 0 0 1 5.36 5.125l.004.239v2.908h.922c.605 0 1.094.49 1.094 1.095v9.558c0 .603-.49 1.094-1.094 1.094H5.73c-.604 0-1.094-.49-1.094-1.094v-9.558c0-.605.49-1.095 1.094-1.095h.922V7.164A5.365 5.365 0 0 1 12.017 1.8zm6.071 9.58H5.945v9.13h12.143v-9.13zm-6.043.805a2.684 2.684 0 0 1 .655 5.288v1.656a.655.655 0 0 1-1.301.106l-.009-.106v-1.656a2.686 2.686 0 0 1 .655-5.288zm0 1.309a1.375 1.375 0 1 0-.001 2.75 1.375 1.375 0 0 0 .001-2.75zm-.028-10.385a4.056 4.056 0 0 0-4.05 3.84l-.006.215v2.908h8.111V7.164a4.055 4.055 0 0 0-4.055-4.055z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconLock
